import { parseTkLiteral, TK_MARKER_SELECTOR } from './recognition';

/**
 * Убирает из разметки метки, которые не должны попасть в статистику.
 *
 * Третья из трёх точек инварианта целостности — и единственная, где ProseMirror
 * не участвует вовсе: пересчёт по проекту идёт прямо по HTML-строке.
 *
 * Убираются ТОЛЬКО метки с валидным литералом. Span с испорченным содержимым
 * остаётся на месте и считается как обычная проза — иначе подделанный или
 * битый `data-tk-marker` прятал бы из подсчёта произвольный текст, а править
 * HTML заметки может кто угодно, в том числе LLM через MCP. Симметрично
 * `parseHTML` у самого узла: «метка» — это узел с валидным литералом, и оба
 * пути понимают это одинаково.
 */
export function stripTkMarkers(root: ParentNode): void {
  root.querySelectorAll(TK_MARKER_SELECTOR).forEach((element) => {
    if (parseTkLiteral(element.textContent ?? '')) {
      element.remove();
    }
  });
}
